module.exports = __webpack_public_path__ + "img/flow3.9596d765.png";